'use strict';

var _faxLine = require('./fax-line');

var _faxLine2 = _interopRequireDefault(_faxLine);

var _teamMembers = require('./team-members');

var _teamMembers2 = _interopRequireDefault(_teamMembers);

var _collection = require('common/models/base/collection');

var _collection2 = _interopRequireDefault(_collection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _collection2['default'].extend({

    /**
    */

    mixins: [require('common/models/mixins/collection')],

    /**
    */

    apiEndpointAlias: 'faxLines',

    /**
    */

    createModel: function createModel(properties) {
        properties.notifier = this.notifier;
        properties.user = this.user;
        return _faxLine2['default'].create(properties);
    },

    /**
    */

    addFaxLine: function addFaxLine(properties) {
        return this.createModel(properties).insert();
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/fax-lines.js
 ** module id = 392
 ** module chunks = 0
 **/